import LockIcon from "@mui/icons-material/Lock";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { FeatureFlagDisplayName } from "./featureFlags";

export enum TestId {
  NotLicensed = "notLicensed"
}

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    backgroundColor: "#F5F7F7"
  }
}));

interface NotLicensedProps {
  feature: string;
}

/**
 * Shown when a user reaches a capability their tenant has not licensed — typically via a deep link,
 * bookmark or stale tab, since unlicensed entry points are otherwise absent.
 *
 * Deliberately distinct from AccessDenied: "your company did not buy this" is a different problem
 * from "your role does not allow this", and conflating them sends users to the wrong person.
 */
export default function NotLicensed({ feature }: NotLicensedProps) {
  const classes = useStyles();
  const displayName = FeatureFlagDisplayName[feature] ?? feature;

  return (
    <Box className={classes.container} data-testid={TestId.NotLicensed}>
      <LockIcon fontSize="large" />
      <Typography variant="h6">
        {displayName} is not included in your licence
      </Typography>
      <Typography variant="body2">
        This feature is not part of your organisation&apos;s current licence.
        Contact your administrator if you need access to it.
      </Typography>
    </Box>
  );
}
